import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';

export function* setRate({ payload }) {
  try {
    const res = yield call(api, {
      method: 'post',
      url: URL.PAY,
      data: { rate: payload.rate },
    });
    const { data: { data, sign } } = res;
    window.open(`https://bank.paysera.com/pay/?data=${data}&sign=${sign}`);
    yield put({ type: 'SET_RATE_SUCCESS', payload: res.data });
  } catch (e) {
    yield put({ type: 'SET_RATE_ERROR' });
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.SET_RATE, setRate);
}
